/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Browser_Ext_Complete_Sign_In_PopupInputs */

const en_browser_ext_complete_sign_in_popup = /** @type {(inputs: Browser_Ext_Complete_Sign_In_PopupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete sign-in in the popup window. If nothing happened, please try again.`)
};

const es_browser_ext_complete_sign_in_popup = /** @type {(inputs: Browser_Ext_Complete_Sign_In_PopupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa el inicio de sesión en la ventana emergente. Si no pasó nada, inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Complete sign-in in the popup window. If nothing happened, please try again." |
*
* @param {Browser_Ext_Complete_Sign_In_PopupInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const browser_ext_complete_sign_in_popup = /** @type {((inputs?: Browser_Ext_Complete_Sign_In_PopupInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Browser_Ext_Complete_Sign_In_PopupInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_browser_ext_complete_sign_in_popup(inputs)
	return en_browser_ext_complete_sign_in_popup(inputs)
});